import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

/**
 * Hook para scroll automático para seções específicas
 * Detecta hash na URL ou parâmetro de rota e faz scroll suave para a seção correspondente
 */
const useScrollToSection = () => {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    let sectionId = null;

    // Verifica se há um parâmetro serviceSlug na rota
    if (params.serviceSlug) {
      sectionId = params.serviceSlug;
    }
    // Senão, verifica se há um hash na URL (ex: #automacao-whatsapp)
    else if (location.hash) {
      sectionId = location.hash.substring(1);
    }

    if (sectionId) {
      // Aguarda um pouco para garantir que a página carregou
      const timer = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Calcula a posição considerando o header fixo (altura aproximada de 80px)
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 500); // Delay maior para garantir que a página carregou completamente

      return () => clearTimeout(timer);
    }
  }, [location.hash, location.pathname, params.serviceSlug]);
};

export default useScrollToSection; 